import Invoice from 'model/Invoice'

import globalFnFactory from 'components/globalFn/globalFnFactory'
import modalInvoiceInfo from './view/modalInvoiceInfo.html'

const globalFn = globalFnFactory()
class modalListCtrl {
  constructor(
    $scope,
    $uibModalInstance,
    items1,
    httpRequest,
    $uibModal,
    hasPDFReader
  ) {
    const allInvoiceList = items1.modalListData
    const { currentInvoicId } = items1
    $scope.currentIndex = -1
    httpRequest.get_dictByTypeArr(['ovat_tax_rate']).then((res) => {
      $scope.ivatTaxRate = res.data.value.ovat_tax_rate
    })
    $scope.init = function (paramId) {
      httpRequest.get_selectBillDetailById(paramId).then((res) => {
        $scope.reimburseDeitalFrom = res.data.value
        $scope.invoiceType = $scope.reimburseDeitalFrom.invoiceType
        $scope.ispdf = false // 票据影像类型
        $scope.noimg = false // 无票据影像类型
        $scope.isNormalInvoice =
          $scope.invoiceType == '0' ||
          $scope.invoiceType == '2' ||
          $scope.invoiceType == '51' ||
          $scope.invoiceType == '12' ||
          $scope.invoiceType == '14' ||
          $scope.invoiceType == '41' ||
          $scope.invoiceType == '15'
        for (let i = 0; i < allInvoiceList.length; i++) {
          if ((allInvoiceList[i].invoiceId || allInvoiceList[i]) == paramId) {
            $scope.currentIndex = i
            break
          }
        }
        $scope.showPreTask = $scope.currentIndex != 0
        $scope.showNextTask = $scope.currentIndex != allInvoiceList.length - 1
        // 截取验证码 切换图片
        if ($scope.reimburseDeitalFrom.checkCode) {
          $scope.reimburseDeitalFrom.checkCode = $scope.reimburseDeitalFrom.checkCode.substring(
            $scope.reimburseDeitalFrom.checkCode.length - 6
          )
        }
        if (
          $scope.reimburseDeitalFrom.fileInfo &&
          $scope.reimburseDeitalFrom.fileInfo.fileType == 'pdf'
        ) {
          $scope.ispdf = true
          if (hasPDFReader()) $scope.canShowPDF = true
        }
        const imagKey = $scope.reimburseDeitalFrom.fileInfo
          ? $scope.reimburseDeitalFrom.fileInfo.storageKey
          : ''
        if ($scope.reimburseDeitalFrom.fileInfo) {
          $scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${imagKey}`
        } else {
          $scope.noimg = true
          $scope.imgSrc = ''
          if ($scope.reimburseDeitalFrom.verifyStatus == 1) {
            httpRequest
              .get_getInvoice({
                invoiceCode: $scope.reimburseDeitalFrom.invoiceCode,
                invoiceNumber: $scope.reimburseDeitalFrom.invoiceNumber,
              })
              .then((res) => {
                $scope.invoice = new Invoice(res.data.value)
                $scope.invoice.invType = $scope.invoice.invoiceType
                $scope.invoice.chineseAmtTotal = globalFn.digitUppercase(
                  $scope.invoice.adValoremTotal
                )
                if (
                  res.data.value.invoiceType == '41' ||
                  res.data.value.invoiceType == '12' ||
                  res.data.value.invoiceType == '15'
                )
                  $scope.codeVersions = $scope.invoice.details[0].revenueVersion
              })
          }
        }
      })
    }
    $scope.init(currentInvoicId)

    $scope.$watch('currentIndex', (newValue) => {
      // 控制页码显示
      if (newValue < 1) {
        $scope.showPreTask = false
      } else {
        $scope.showPreTask = true
      }
      if (newValue >= allInvoiceList.length - 1) {
        $scope.showNextTask = false
      } else {
        $scope.showNextTask = true
      }
    })

    $scope.changeTask = function (
      changeFlag // -1上一条 1下一条
    ) {
      if (
        ($scope.currentIndex <= 0 && changeFlag == -1) ||
        ($scope.currentIndex >= allInvoiceList.length - 1 && changeFlag == 1)
      ) {
        return
      }
      if (changeFlag == 1) {
        $scope.currentIndex += 1
      } else if (changeFlag == -1) {
        $scope.currentIndex -= 1
      }
      $scope.init(
        allInvoiceList[$scope.currentIndex].invoiceId ||
          allInvoiceList[$scope.currentIndex]
      )
    }

    $scope.cancel = () => {
      $uibModalInstance.close()
    }
    $scope.ok = () => {
      $uibModalInstance.close()
    }
    $scope.checkSuccess = function (item) {
      $('iframe').hide()
      $uibModal
        .open({
          template: modalInvoiceInfo,
          openedClass: 'mod-modal mod-invoice-info',
          animation: true,
          controller: 'modalInvoiceInfo',
          resolve: {
            invoice() {
              return {
                invoiceCode: item.invoiceCode,
                invoiceNumber: item.invoiceNumber,
              }
            },
          },
        })
        .result.then()
        .finally(() => {
          $('iframe').show()
        })
    }
  }
}

modalListCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'items1',
  'httpRequest',
  '$uibModal',
  'hasPDFReader',
]
export default modalListCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/modalListCtrl.js